import React from 'react';
import { Paper, Typography, Stack, Divider, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useCurrency from '../../../hooks/common/useCurrency';

const Field = ({ label, value }) => (
    <Box>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Typography variant="body2" fontWeight="medium">{value || '-'}</Typography>
    </Box>
);

const ReturnShippingCard = ({ data }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { format: formatPrice } = useCurrency();

    const carrier = data?.carrier || data?.shipping?.carrier;
    const tracking = data?.tracking_number || data?.shipping?.tracking_number;
    const cost = data?.shipping_cost ?? data?.shipping?.cost;
    const paidBy = data?.shipping_paid_by || data?.shipping?.paid_by;

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, md: 3 },
                borderRadius: 3,
                border: (t) => `1px solid ${t.palette.divider}`,
                mb: 3,
            }}
        >
            <Typography variant="h6" fontWeight={700} mb={2}>
                {isArabic ? 'بيانات الشحن العكسي' : 'Return Shipping'}
            </Typography>

            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                divider={<Divider orientation="vertical" flexItem />}
                flexWrap="wrap"
            >
                <Field label={isArabic ? 'شركة الشحن' : 'Carrier'} value={carrier} />
                <Field label={isArabic ? 'رقم التتبع' : 'Tracking #'} value={tracking} />
                <Field
                    label={isArabic ? 'تكلفة الشحن' : 'Shipping Cost'}
                    value={cost != null ? formatPrice(cost) : '-'}
                />
                <Field
                    label={isArabic ? 'يتحمل التكلفة' : 'Paid By'}
                    value={
                        paidBy === 'customer'
                            ? (isArabic ? 'العميل' : 'Customer')
                            : paidBy === 'store'
                                ? (isArabic ? 'المتجر' : 'Store')
                                : paidBy
                    }
                />
            </Stack>
        </Paper>
    );
};

export default ReturnShippingCard;
